import React, { useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import { usePushNotifications } from '../../hooks/usePushNotifications';

/**
 * One-time prompt to open the native browser permission dialog when permission is still "default".
 */
const BrowserPushPrompt = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { pushSupported, browserPermission, syncing, requestBrowserPermission } =
    usePushNotifications();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('js_push_prompt_dismissed') === '1'
  );

  const role = user?.user_type;
  const showForRole =
    role === 'JetSetter' || role === 'Airliner' || role === 'SubAdmin';

  if (
    !user?.id ||
    !showForRole ||
    !pushSupported ||
    dismissed ||
    browserPermission !== 'default'
  ) {
    return null;
  }

  const handleEnable = async () => {
    try {
      await requestBrowserPermission();
    } catch (err) {
      window.alert(err?.message || 'Could not enable notifications. Check browser settings.');
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem('js_push_prompt_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[9999] bg-gray-900 text-white rounded-lg shadow-lg p-4 flex flex-col gap-3"
      role="dialog"
      aria-label="Enable push notifications"
    >
      <p className="text-sm font-medium">Get booking alerts in your browser</p>
      <p className="text-xs text-gray-300">
        Allow notifications when prompted so you do not miss new bookings, acceptances, or
        cancellations. You can change this anytime in your browser site settings.
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={syncing}
          onClick={handleEnable}
          className="flex-1 px-3 py-2 text-sm font-medium bg-[#ffd000] text-gray-900 rounded hover:bg-yellow-400 disabled:opacity-50"
        >
          {syncing ? 'Enabling…' : 'Allow notifications'}
        </button>
        <button
          type="button"
          onClick={handleDismiss}
          className="px-3 py-2 text-sm text-gray-300 hover:text-white"
        >
          Not now
        </button>
      </div>
    </div>
  );
};

export default BrowserPushPrompt;
